import React, { useState, useCallback } from 'react';

import { ModalPage } from 'src/components/base/Page';
import DefaultButtonEx from '@v2/components/base/DefaultButtonEx'

import Mapping from './Mapping';


export function Button({ mappingManager, label = 'Mappings', isDisabled, isEditingDisabled, showError = true }) {
  const [isOpen, setIsOpen] = useState(false);

  if (!mappingManager) {
    return null;
  }

  const { mapping: ms, constants: cs, hasAnyError, generalErrors } = mappingManager.status;
  const mappingTooltip = !hasAnyError
    ? `${ms.usedCount} out of ${ms.totalCount} headers are mapped to the fields and ${cs.totalCount} constants are created`
    : '';
  const errorText = [...ms.errors, ...cs.errors, ...generalErrors].map(x => x.message).join('; ');

  const handleOpenMappingPage = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleApplyMapping = useCallback(() => {
    setIsOpen(false);
  }, []); 

  const mappingsComponent = useCallback((props) => {
    return <Mapping
      onChange={handleApplyMapping}
      mappingManager={mappingManager}
      isDisabled={isEditingDisabled}
      {...props}
    />
  }, [mappingManager, isEditingDisabled, handleApplyMapping]);

  return (
    <>
      <DefaultButtonEx
        text={label}
        onClick={handleOpenMappingPage}
        disabled={isDisabled}
        tooltip={mappingTooltip}
        primary={true}
        error={showError && hasAnyError && errorText}
      />

      <ModalPage title={label}
        isOpen={isOpen}
        onClose={handleApplyMapping}
        component={mappingsComponent}
      />

    </>
  );
}